/**
 * Carousel Logo - Alpine.js data component for sport-cycling team logo carousel
 *
 * Manages active sport state and auto-cycling between sports on a timer.
 * Short-circuits when only one sport is available to avoid wasted intervals.
 *
 * Usage (in Blade):
 *   x-data="carouselLogo('{{ $defaultSport }}', {{ Js::from($sports) }})"
 *
 * @param {string} defaultSport - Initially active sport slug
 * @param {Array<string>} sports - Available sport slugs to cycle through
 * @returns {object} Alpine data component
 */
export default function carouselLogo(defaultSport, sports) {
  return {
    activeSport: defaultSport,
    sports,
    cycleSports: true,
    cycleInterval: null,

    init() {
      this.startCycle();
    },

    destroy() {
      this.stopCycle();
    },

    startCycle() {
      if (!this.cycleSports || this.sports.length <= 1) return;

      const speed = window.matchMedia('(min-width: 768px)').matches
        ? 80000
        : 30000;

      this.cycleInterval = setInterval(() => {
        const currentIndex = this.sports.indexOf(this.activeSport);
        this.activeSport = this.sports[(currentIndex + 1) % this.sports.length];
      }, speed);
    },

    stopCycle() {
      if (this.cycleInterval) {
        clearInterval(this.cycleInterval);
        this.cycleInterval = null;
      }
    },

    selectSport(sport) {
      this.activeSport = sport;
      this.stopCycle();
    },
  };
}
